export default class MatomoSourceService {
  private static instance: MatomoSourceService = new MatomoSourceService();

  private constructor() {}

  public static singleton(): MatomoSourceService {
    return this.instance;
  }

  private matomoSource: string;

  public configure(el: HTMLElement) {
    if (el) {
      const matomoSource = el.dataset.matomoSource;

      if (matomoSource) {
        this.matomoSource = matomoSource;
      }
    }
  }

  public getMatomoSourceOfPage(): string {
    return this.matomoSource;
  }
}
